import Menu from './header-footer/header';
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div>
      <div className='row'>
        <div className='col-sm-2'>
            <Menu/>
        </div>
        <div id="app-body" className='col-sm-10'>
            <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
